import api from '@/services/api/client';
import type { ThemeDefinition } from '@/utils/themeDerivation';

export interface ThemeContextResponse {
  canManageGlobal: boolean;
  editablePartnerOrganizationId: number | null;
  /** Om det globala temat är aktiverat (runtime). */
  globalThemeEnabled: boolean;
}

export interface OrganizationThemeResponse {
  theme: ThemeDefinition;
  hasCustomTheme: boolean;
  /** Om partnerns tema är aktiverat. */
  enabled: boolean;
  globalTheme: ThemeDefinition;
}

export interface PartnerOption {
  id: number;
  name: string;
}

export const themeSettingsApi = {
  getContext: async (): Promise<ThemeContextResponse> => {
    const res = await api.get<{ success: boolean; data: ThemeContextResponse }>('/api/theme-settings/context');
    return res.data.data;
  },

  getGlobalTheme: async (): Promise<ThemeDefinition> => {
    const res = await api.get<{ success: boolean; data: ThemeDefinition }>('/api/theme-settings/global');
    return res.data.data;
  },

  updateGlobalTheme: async (theme: ThemeDefinition): Promise<ThemeDefinition> => {
    const res = await api.put<{ success: boolean; data: ThemeDefinition }>('/api/theme-settings/global', theme);
    return res.data.data;
  },

  getOrganizationTheme: async (organizationId: number): Promise<OrganizationThemeResponse> => {
    const res = await api.get<{ success: boolean; data: OrganizationThemeResponse }>(
      `/api/theme-settings/organization/${organizationId}`,
    );
    return res.data.data;
  },

  updateOrganizationTheme: async (organizationId: number, theme: ThemeDefinition): Promise<ThemeDefinition> => {
    const res = await api.put<{ success: boolean; data: ThemeDefinition }>(
      `/api/theme-settings/organization/${organizationId}`,
      theme,
    );
    return res.data.data;
  },

  listPartners: async (): Promise<PartnerOption[]> => {
    const res = await api.get<{ success: boolean; data: PartnerOption[] }>('/api/theme-settings/partners');
    return res.data.data;
  },
};
